import { gradeConstants } from '../../constants';

const initialGradesState = {
  gradesList: [] as any[],
};

export function grades(state = initialGradesState, action: any) {
  switch (action.type) {
    case gradeConstants.GETALL_REQUEST:
      return { loading: true };
    case gradeConstants.GETALL_SUCCESS:
      return { ...state, gradesList: action.payload };
    case gradeConstants.GETALL_FAILURE:
      return { error: action.payload };
    case gradeConstants.CREATE_SUCCESS:
      return { gradesList: [...state.gradesList, action.payload] };
    case gradeConstants.DELETE_SUCCESS:
      return { 
        ...state, 
        gradesList: state.gradesList.filter(grade => grade.id !== action.payload)
      };
    case gradeConstants.UPDATE_SUCCESS:
      return { 
        ...state, 
        gradesList: state.gradesList.map(grade =>
          grade.id === action.payload.id ? action.payload : grade
        ),
      };
    default:
      return state;
  }
}
